<template>
    <td-dialog v-dialogDrag :title="title" :before-close="setupDialogClose" :visible.sync="dialogSetupVisible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form class="newClass" :model="formProtInfo" ref="formProtInfo">
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item v-loading="showLoading"> </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item :label="setupInfo" prop="setupInfo"> </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <span slot="footer">
            <td-button type="primary" @click="setupDialogClose" v-show="confirmShow">{{ $t('common.CONFIRM') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import mqApi from '../assets/api.js';
export default {
    props: ['title', 'dialogSetupVisible', 'promtInfo', 'setItem'],
    created() {},
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.showLoading = true;
        this.confirmShow = false;
        this.setupInfo = this.setItem.sName + this.$t('message.DOWNLOADING_SETUP');
        this.dowanLoadSetup();
    },
    // 定义变量
    data() {
        return {
            confirmShow: '',
            setupInfo: ''
        };
    },
    // 定义并实现方法体
    methods: {
        dowanLoadSetup() {
            if (this.setItem === null || this.setItem.sId === null) {
                this.showLoading = false;
                this.confirmShow = true;
                this.setupInfo = this.$t('error.ERROR_PARAMETER');
                return;
            }
            let mqId = this.setItem.sId;
            let name = this.setItem.sName;
            mqApi.distributeConfigInfo({ mqId: mqId }, response => {
                this.showLoading = false;
                this.confirmShow = true;
                if (response.status === undefined) {
                    this.setupInfo = name + this.$t('common.DOWNLOADING_CONFIG_FAIL');
                    return;
                }
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.setupInfo = name + this.$t('common.DOWNLOADING_CONFIG_FAIL');
                    this.$log.error('/mqInfo/distributeConfigInfo', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.setupInfo = name + response.data.statusMessage;
                    this.$log.error('/mqInfo/distributeConfigInfo', response.data.statusMessage);
                    return;
                }
                this.$dataBusUtil.initByMqId(mqId);
                this.setupInfo = name + this.$t('common.DOWNLOADING_CONFIG_SUCCESS');
            });
        },
        setupDialogClose() {
            this.$emit('setupDialogClose');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.newClass .el-form-item {
    text-align: center;
}
.newClass .el-form-item__label {
    float: none !important;
}
</style>
